module.exports = __webpack_public_path__ + "img/2_232.f38d7a7d.png";